// @flow
import type { ThunkAction } from '../../core/types'
import type { ItemDetailModalType, Item } from './types'
import type { MergeAction } from '../../modules/entities'
import { normalize } from 'normalizr'
import { services } from '../../core/feathers'
import { mergeEntities } from '../../modules/entities'
import { hmset, hdelAll } from '../../modules/hash'
import {
  isCommInProgress,
  startCommunication,
  endCommunication
} from '../../modules/communication'
import { batch } from '../../modules/lib/batchReducer'
import { createFetchItemResource, createFetchItemBidsResource } from './utils'
import { domains, schemas } from '../constants'
import {
  ITEM_DETAIL_MODAL,
  FETCH_ITEM_REQUEST,
  FETCH_ITEM_FAILED,
  FETCH_ITEM_SUCCESS,
  FETCH_ITEM_BIDS_REQUEST,
  FETCH_ITEM_BIDS_SUCCESS,
  FETCH_ITEM_BIDS_FAILED,
  OPEN_ITEM_DETAIL_MODAL,
  CLOSE_ITEM_DETAIL_MODAL
} from './constants'

export const openItemDetailModal = (
  modalContent: ItemDetailModalType,
  itemId: number
) =>
  batch(
    OPEN_ITEM_DETAIL_MODAL,
    hmset(ITEM_DETAIL_MODAL, { isOpen: modalContent, itemId: itemId })
  )

export const closeItemDetailModal = () =>
  batch(CLOSE_ITEM_DETAIL_MODAL, hdelAll(ITEM_DETAIL_MODAL))

export const fetchItem = (id: string): ThunkAction =>
  async function(dispatch, getState) {
    const resource: string = createFetchItemResource(id)
    if (isCommInProgress(resource, getState())) {
      console.log('fetchItem called but another one in progress')
      return false
    }
    dispatch(batch(FETCH_ITEM_REQUEST, startCommunication(resource)))
    try {
      const item: Item = await services[domains.ITEMS].get(id, {
        query: { $eager: '[auction]' }
      })
      dispatch(
        batch(FETCH_ITEM_SUCCESS, storeItem(item), endCommunication(resource))
      )
    } catch (error) {
      console.warn(`Error fetching item ${id}`, error)
      dispatch(batch(FETCH_ITEM_FAILED, endCommunication(resource, false)))
      return false
    }
  }

export const storeItem = (item: Object): MergeAction => {
  const { entities } = normalize(item, schemas[domains.ITEMS])
  return mergeEntities(entities)
}

export const fetchItemBids = (itemId: number): ThunkAction => async (
  dispatch,
  getState
) => {
  const resource: string = createFetchItemBidsResource(itemId)
  if (isCommInProgress(resource, getState())) {
    console.log('fetchItemBids called but another one in progress')
    return false
  }
  try {
    dispatch(batch(FETCH_ITEM_BIDS_REQUEST, startCommunication(resource)))
    const item: Item = await services[domains.ITEMS].get(itemId, {
      query: { $eager: '[bids]', $select: ['id'] }
    })
    dispatch(
      batch(
        FETCH_ITEM_BIDS_SUCCESS,
        storeItem(item),
        endCommunication(resource)
      )
    )
  } catch (error) {
    console.warn(`Error fetching bid items ${itemId}`, error)
    dispatch(batch(FETCH_ITEM_BIDS_FAILED, endCommunication(resource, false)))
    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/item/actions.js